module.exports = __webpack_public_path__ + "img/remind-icon4.5c92891d.png";